import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CmCoreModule } from '@ats/cm/core';
import { AtsNotificationService } from '@ats/notifications';
import { LocalizationModule } from '@cm/core/localization';
import { preloadedCP } from '@cp/data/localizations';
import { preloadedSP } from '@sp/data/localizations';
import { IpLoadModuleOnceGuard } from './guards';
import { IpUserService } from './services/ip-user.service';

@NgModule({ exports: [LocalizationModule], imports: [CmCoreModule, LocalizationModule.forChild({ ...preloadedSP, ...preloadedCP })], providers: [IpUserService, AtsNotificationService, provideHttpClient(withInterceptorsFromDi())] })
export class IpCoreModule extends IpLoadModuleOnceGuard {
	constructor(@Optional() @SkipSelf() parentModule: IpCoreModule) {
		super(parentModule);
	}
}
